import axios from "axios";
import React, { Component } from "react";
import { ajaxUri } from "../consts";
import GKEvent from "../events";
import { l } from "../functions";
import {
  deletePage,
  createPage,
  changePage,
  savePage,
  showEye,
} from "../core/redux/api/pages";
import PageDialog from "./PageDialog";
import { connect } from "react-redux";
import PageTemplates from "./PageTemplates";

import {
  updatePayloadHistory,
  setHistorying,
} from "../core/redux/api/payloads";
import Icons from "./Icons";

function mapStateToProps(state) {
  return {
    fetchedPages: state.rootReducer.fetchedPages || [],
  };
}

export class PageSettings extends Component {
  constructor(props) {
    super(props);
    this.defaultState = {
      currentTab: "page",
      pageDatas: null,
      newPage: false,
      unsaved: false,
      removingPage: null,
      currentPage: null,
      importingTemplate: null,
    };

    this.state = this.defaultState;
  }

  componentDidMount() {
    let page = {};
    this.props.fetchedPages.map((cPage, index) => {
      if (this.props.currentPage === cPage.key) {
        page = cPage;
      }
    });
    this._editPage(page);
    if (page?.layouts) {
      this.setState({ importingTemplate: page.layouts });
    }
  }

  _saveSettings = (globalSettings) => {
    if (
      this.state?.pageDatas &&
      [
        "terms-and-conditions",
        "privacy-policy",
        "shipping-policy",
        "refund-policy",
      ].includes(
        this.state?.pageDatas["link_rewrite_" + this.props.currentLang]
      )
    ) {
      return;
    }
    if (
      globalSettings?.previous_order_id > globalSettings?.EZCONF_NEW_ORDER_ID
    ) {
      return;
    }
    if (this.state.pageDatas) {
      GKEvent.updatePageSetting(this.state.pageDatas.background);
      this.props.createPage(
        this.state.pageDatas,
        (this.state.currentPage && this.state.currentPage.key) || null
      );
    }
    if (globalSettings) {
      for (const setting in globalSettings) {
        if (["error", "previous_order_id"].includes(setting)) {
          continue;
        }
        this._setGlobalSetting(setting, globalSettings[setting]);
      }
    }

    GKEvent.notification("success", "Page settings updated successfully");
  };

  _setGlobalSetting = (key, value) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "setSetting",
        key: key,
        value: value,
      },
    })
      .then((result) => {})
      .catch((error) => {
        GKEvent.notification("error", l("Error."));
      });
  };

  _changedValue = (key, value) => {
    this.setState(
      {
        ...this.state,
        pageDatas: {
          ...this.state.pageDatas,
          [key]: value,
        },
      },
      () => {
        this.setState({ unsaved: true });
      }
    );
  };
  _cleanPage = () => {
    this.setState(this.defaultState);
  };

  _editPage = (page) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "getPageSettings",
        pageid: page.key,
      },
    })
      .then((result) => {
        if (result.data.status === "success")
          this.setState({
            pageDatas: result.data.datas,
            currentPage: page,
            pageType: page.type,
          });
        else GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error while loading the page settings. Please try again.")
        );
      });
  };

  _getFields = () => {
    let fields = [];
    if (this.state.currentTab === "seo") {
      fields = [
        {
          id: "meta_title",
          label: l("Title"),
          multiline: false,
          multilang: true,
          solid: true,
        },
        {
          id: "meta_keywords",
          label: l("Keywords"),
          multiline: true,
          multilang: true,
          solid: true,
        },
        {
          id: "meta_description",
          label: l("Description"),
          multiline: true,
          multilang: true,
          solid: true,
        },
        {
          id: "link_rewrite",
          label: l("Friendly URL"),
          multiline: false,
          pageType: "cms",
          multilang: true,
          solid: true,
        },
        { hr: true },
      ];
    }

    if (this.state.currentPage && this.state.currentPage.key === "checkout")
      fields.push(
        ...[
          { globalSettings: "EZCONF_ENABLE_FLOAT_CHECKOUT" },
          { globalSettings: "EZCONF_NEW_ORDER_ID" },
          { globalSettings: "EZCONF_CUSTOM_ORDER_THANKS_PAGE_URL" },
          { hr: true },
        ]
      );

    if (this.state.currentTab === "page")
      fields.push(
        ...[
          {
            id: "background",
            background: true,
          },
        ]
      );

    if (this.state.currentPage && this.state.currentPage.key === "thankyou")
      fields.push(
        ...[
          {
            message: l(
              "Javascript variables:<br />Total cart value: <strong>total_paid_tax_excl</strong><br />Order number: <strong>id_thanks_order</strong>"
            ),
          },
        ]
      );

    if (this.state.currentTab === "seo") {
      fields.push(
        ...[
          { title: l("Code Includes (Tracking, GA, etc…)") },
          {
            id: "pageScriptHead",
            label: l("HTML <head>"),
            multiline: true,
          },
          {
            id: "pageScriptBodyBefore",
            label: l("HTML <body> top"),
            multiline: true,
          },
          {
            id: "pageScriptBodyAfter",
            label: l("HTML <body> bottom"),
            multiline: true,
          },
        ]
      );
    }

    if (
      this.state.currentPage?.key === "home" &&
      this.state.currentTab === "seo"
    ) {
      fields.push(
        ...[
          { hr: true },
          { title: l("Open Graph (Social Share) Settings") },
          {
            id: "og_image",
          },
          {
            id: "og_title",
            label: l("OG Title"),
            multiline: true,
          },
          {
            id: "og_desc",
            label: l("OG Description"),
            multiline: true,
          },
        ]
      );
    }

    return fields;
  };

  _saveLayout = (datas) => {
    this.props.setHistorying(true);
    this.props.updatePayloadHistory(JSON.parse(datas.payload));
    this.props.savePage(false);
  };

  _showWarning = (key) => {
    if (this.state.currentTab == "page") {
      return false;
    }
    if (!key) {
      return false;
    }

    if (
      key.includes("upsell") ||
      key.includes("product_") ||
      key === "category"
    ) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    console.log(this.state.currentPage);
    return (
      <div className="page-settings">
        <div className="page-settings-menu">
          <span>{(this.state.currentPage?.name || "page") + " settings"}</span>
          <ul>
            <li
              onClick={() => this.setState({ currentTab: "page" })}
              className={`${this.state.currentTab === "page" ? "active" : ""}`}
            >
              Page Settings
            </li>
            <li
              onClick={() => this.setState({ currentTab: "seo" })}
              className={`${this.state.currentTab === "seo" ? "active" : ""}`}
            >
              SEO Settings
            </li>
            {this.state.importingTemplate && (
              <li
                onClick={() => this.setState({ currentTab: "template" })}
                className={`${
                  this.state.currentTab === "template" ? "active" : ""
                }`}
              >
                Templates
              </li>
            )}
          </ul>
        </div>
        <div className="page-settings-wrapper">
          {(this.state.currentTab === "page" ||
            this.state.currentTab === "seo") && (
            <>
              {this._showWarning(this.state.currentPage?.key) ? (
                <>
                  <div className="page-dialog">
                    <div className="head">
                      <h3>SEO settings</h3>
                      <div>
                        <Icons icon="time" onClick={this.props.onClose} />
                      </div>
                    </div>
                    <div className="form">
                      <div className="gk-warning-message">
                        you are editing {this.state.currentPage?.key} template.
                        to change SEO go to GK Dashboard
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <PageDialog
                    unsaved={this.state.unsaved}
                    currentPage={this.state.currentPage}
                    newPage={this.state.newPage}
                    pageDatas={this.state.pageDatas}
                    pageType={this.state.pageType}
                    onSubmit={(globalSettings) =>
                      this._saveSettings(globalSettings)
                    }
                    onChange={this._changedValue}
                    onClose={this.props.onClose}
                    currentTab={this.state.currentTab}
                    fields={this._getFields()}
                  />
                </>
              )}
            </>
          )}
          {this.state.currentTab === "template" &&
            this.state.importingTemplate && (
              <PageTemplates
                target={this.state.importingTemplate}
                targetId={this.state.importingTemplate}
                onSubmit={(datas, cb = () => {}) => {
                  this._saveLayout(datas);
                  cb();
                }}
                onClose={this.props.onClose}
              />
            )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  createPage,
  setHistorying,
  updatePayloadHistory,
  savePage,
  deletePage,
  changePage,
  showEye,
})(PageSettings);
